import { PhoneField, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { PHONE_CALL_KINDS } from '../../constants';
import { AdditionalInfo } from '../additional_info';
const wrapperCss = "w7qcfkb";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const InboundCallDetails = () => {
  const [{
    value: selectedKind
  }] = useFormField({
    name: 'kind'
  });
  if (selectedKind !== PHONE_CALL_KINDS.inbound) return null;
  return <Wrapper>
      <PhoneField name="phoneNumber" aria-label={I18n.t('publisher.event_types.invitee_questions.custom.phone_number')} />
      <AdditionalInfo />
    </Wrapper>;
};

require("./inbound_call_details.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./inbound_call_details.js");